import { FeedbackToSlack } from '../entity';
import { FeedbackToSlackId } from '../value';
import { FirestoreQueryBuilder } from 'gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Observable } from 'rxjs';

export abstract class IFeedbackToSlackRepository extends IRepository<FeedbackToSlackId, FeedbackToSlack> {
  abstract selectAll(builder: FirestoreQueryBuilder<FeedbackToSlack>): Observable<FeedbackToSlack>;
}
